import Home from "../../components/home/Home";
import DialogBox from "../../components/UI/DialogBox";
import { handleErrMessage } from "../../functions/handleErrMessage";
import MainPageLayout from "../../layout/MainPageLayout";
import { PAYLOAD, UUID_URL } from "../../api/allApi_List";
import useGetMultiple from "../../CustomHooks/useAxios/useGetMultiple";
import LoadingDisplay from "../../components/UI/LoadingDisplay";

const HomePage = () => {
  const saveData = "payload";
  const { data, isLoaded, error } = useGetMultiple(
    [UUID_URL, PAYLOAD],
    saveData
  );

  if (!isLoaded) return <LoadingDisplay />;
  if (error)
    return (
      <DialogBox
        title="Error"
        message={handleErrMessage(error)}
        isErrorHandleButtons={true}
        isHome={true}
      />
    );
  return (
    <MainPageLayout headerConfig={{ title: "Home" }}>
      <Home data={data[1]} />
    </MainPageLayout>
  );
};

export default HomePage;
